import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Manufacturer } from 'src/app/models';
import { faTimes, faSave } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-manufacturer-dialog',
  templateUrl: './manufacturer-dialog.component.html',
  styles: [``],
})
export class ManufacturerDialogComponent implements OnInit {
  public form: FormGroup;
  public faTimes = faTimes;
  public faSave = faSave;
  constructor(
    public dialogRef: MatDialogRef<ManufacturerDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { manufacturer: Manufacturer; title: string; manufacturers: Manufacturer[] },
  ) {}

  ngOnInit() {
    const formFields: { [key: string]: any } = {
      name: [this.data.manufacturer.name, Validators.required],
    };
    if (this.data.manufacturer.id) {
      formFields.id = [this.data.manufacturer.id];
      formFields.createdBy = [this.data.manufacturer.createdBy];
      formFields.createdTime = [this.data.manufacturer.createdTime];
    }
    this.form = this.fb.group(formFields);
  }
  cancel() {
    this.dialogRef.close(null);
  }

  save() {
    this.dialogRef.close(this.form.value);
  }
}
